import { render, staticRenderFns } from "./LexonColorPickerComponent.vue?vue&type=template&id=6b7cdaf8&scoped=true&lang=pug"
import script from "./LexonColorPickerComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LexonColorPickerComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LexonColorPickerComponent.vue?vue&type=style&index=0&id=6b7cdaf8&scoped=true&lang=scss"
import style1 from "./LexonColorPickerComponent.vue?vue&type=style&index=1&id=6b7cdaf8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7cdaf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7cdaf8')) {
      api.createRecord('6b7cdaf8', component.options)
    } else {
      api.reload('6b7cdaf8', component.options)
    }
    module.hot.accept("./LexonColorPickerComponent.vue?vue&type=template&id=6b7cdaf8&scoped=true&lang=pug", function () {
      api.rerender('6b7cdaf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonColorPicker/LexonColorPickerComponent.vue"
export default component.exports